<template>
  <div id="app">
    <Home/>
  </div>
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'app',
  components: {
    Home
  }
}
</script>

<style>
#app {
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000000;
}

/* ALIGN */
.vcenter{
  align-self: center;
}
.vbottom{    
  align-self: end;
}
.form-control{
  border: #000000 1px solid !important;
  outline: none !important;
  box-shadow: none !important;
}
.navbar-toggler{
  outline: none;
  border: none;
}
.nav-link{
  text-decoration: underline !important;
}


textarea,
select,
input[type="text"],
input[type="button"],
input[type="submit"] {
  -webkit-appearance: none !important;
  appearance: none !important;
  border-radius: 0 !important;
  -webkit-border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
